<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Pendientes de Aprobación</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group
                :label="crearLabel('Ejecutivos', 'codejecutivo', 'datosFormulario')"
                label-for="codejecutivo"
              >
                <b-form-select
                  :options="valEjecutivos"
                  v-model="datosFormulario.codejecutivo"
                  :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.codejecutivo }}</span>
              </b-form-group>
            </b-col>
            
            <b-col sm="2">
              <b-form-group 
                :label="crearLabel('Código Asegurado', 'codasegurado', 'datosFormulario')"
                label-for="codasegurado">
                <b-form-input
                  id="codasegurado"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.codasegurado"
                  :disabled="campoBloqueado('codasegurado', 'datosFormulario')"
                  @change="buscarAsegurado">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codasegurado }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group 
                :label="crearLabel('Asegurado', 'desasegurado', 'datosFormulario')"
                label-for="desasegurado">
                <b-form-input
                  id="desasegurado"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.desasegurado"
                  :disabled="true">
                </b-form-input>
              
              </b-form-group>
            </b-col>

          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                  <b-button variant="success" @click="multipleSelection.length > 0? modalAutorizar = true: modalAutorizar = false" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-check"></i> Autorizar
                  </b-button>
                  <b-button variant="danger" @click="multipleSelection.length > 0? modalRechazar = true: modalRechazar = false" style="margin-left: 10px;">
                    <i class="fa fa-ban"></i> Rechazar
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Pendientes de Aprobación</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange">
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                  <el-table-column label="Observación" min-width="250px" align="left">
                    <template slot-scope="scope">
                      <el-tooltip
                          v-for="button in customButtonsForRowObs(scope.row)"
                          :key="button.id"
                          :content="button.tooltip"
                          placement="top">
                          <el-button
                            type="text"
                            @click="button.handler"
                          >
                            <i v-bind:class="button.icon"></i>
                            {{ button.name }}
                          </el-button>
                      </el-tooltip>
                      {{ scope.row.OBSERVACION }}
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="Documentación" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <el-tooltip
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                          :content="button.tooltip"
                          placement="top">
                          <el-button
                            type="text"
                            @click="button.handler"
                          >
                            <i v-bind:class="button.icon"></i>
                            {{ button.name }}
                          </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column> -->

                  <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="DocContishare(scope.row.SINIESTRO,scope.row)">Ver</el-button>   
                  </template>
                  </el-table-column>

                  <el-table-column type="selection" width="35" reserve-selection><!-- reserve-selection -->
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      title="Autorizar"
      cancel-title="Cancelar"
      ok-title="Autorizar"
      class="modal-success"
      v-model="modalAutorizar"
      @cancel="modalAutorizar = false"
      @ok="autorizar();"
    >
        Esta seguro de autorizar los registros seleccionados?  
    </b-modal>

    <b-modal
      title="Rechazar"
      cancel-title="Cancelar"
      ok-title="Rechazar"
      class="modal-success"
      v-model="modalRechazar"
      @ok="rechazar();"
      @cancel="modalRechazar = false"
    >
        Esta seguro de rechazar los registros seleccionados?  
    </b-modal>

    <b-modal
      title="Observación"
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalObservacion"
      @ok="guardarObservacion();"
      @cancel="modalObservacion = false"
    >
      <b-form-textarea
        id="obs"
        v-model="modalDataObservacion.OBSERVACION"
        placeholder="Ingrese la observación"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>

     <!-- Detalle Documentación de Contishare -->
   <b-modal
      hide-footer
      size="lg"
      :title="'Documentación siniestro ' + this.nroSiniestroSeleccionado"
      cancel-title="Cerrar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalDocContishare"
      @cancel="modalDocContishare = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataDocContishare"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                               
                >
                  <el-table-column
                    v-for="title in titlesDocContishare"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                  
                  <el-table-column label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="verDocumento(scope.row.LINK)">Ver</el-button>   
                  </template>
                  </el-table-column>

                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>


  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiNomPendVB from "@/components/services/apiNomPendVB";
import apiNomina from "@/components/services/apiNomina";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "PendientesdeAprobación",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      exportar: false,
      tieneAcceso: true,
      modalGuardar: false,
      modalAutorizar: false,
      modalRechazar: false,
      modalObservacion: false,
      modalDataObservacion: "",
      modalDocContishare: false,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      nroSiniestroSeleccionado: 0,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data: [],
      dataDocContishare: [],
      nombreexcel: "PendientesdeAprobación",
      titles: [
        {
          prop: "SINIESTRO",
          label: "Siniestro",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "EJECUTIVO",
          label: "Ejecutivo",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "PRODUCTO",
          label: "Producto",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "ASEGURADO",
          label: "Asegurado",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "BENEFICIARIO",
          label: "Beneficiario",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "left",
          minwidth: "100",
        },
        {
          prop: "MONTO",
          label: "Monto a Indemnizar",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "ESTADO",
          label: "Estado",
          align: "left",
          minwidth: "150",
        }
      ],

      titlesDocContishare: [
        {
          prop: "CSHTITULO",
          label: "Nombre Documento",
          align: "left",
          minwidth: "250",
        },        
      ],
      
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              } else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      mostrarFechas: true,
      datosFormulario: {},
      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      valEjecutivos: [],

      multipleSelection: [],
      multipleSelectionDelete: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "Siniestro",
        rowClassName({ row, rowIndex}) {
            if(row.ESTADO == "REC"){
                return 'warning-row';
            }
            else{
                return 'estiloFilaTabla';
            }
        }
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {

    verDocumento(link) {
      window.open(link, '_blank');
    },

    // customButtonsForRow(row) {
    //       var botones = new Array();
          
    //       if (row.INFORME)
    //       {
    //         var obj = new Object();
    //         obj.tooltip = "Informe Liquidación";
    //         obj.id = 1;
    //         obj.name="";
    //         obj.icon = "fa fa-file-pdf-o";
    //         obj.type = "success";
    //         obj.handler= _ => {
    //             this.$session.start();
    //             window.open(row.INFORME, '_blank');
    //         }
    //         botones.push(obj);
    //       }

    //       if (row.CORREO)
    //       {
    //         var obj = new Object();
    //         obj.tooltip = "Correo";
    //         obj.id = 2;
    //         obj.name="";
    //         obj.icon = "fa fa-envelope-o";
    //         obj.type = "success";
    //         obj.handler= _ => {
    //             this.$session.start();
    //             window.open(row.CORREO, '_self');
    //         }
    //         botones.push(obj);
    //       }
          
    //       return botones;

    // },

    customButtonsForRowObs(row) {
          var botones = new Array();
          
          if (row.observacion == undefined || row.observacion == '')
          {
            var obj = new Object();
            obj.tooltip = "Modificar";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-pencil-square-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.modalDataObservacion = row;
                this.modalObservacion = true;
            }
            botones.push(obj);
          }
          
          return botones;

    },

    getDate(date) {
      let elDate = new Date(date)
      return elDate.getDate() + '/' + (elDate.getMonth() + 1) + '/' + elDate.getFullYear();   
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    cambiarFechas() {
      if (this.datosFormulario.selected == "A") {
        this.mostrarFechas = false;
      } else {
        this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      console.log(n);
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      return apiNomPendVB
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
            this.datosFormulario.codasegurado = lista_data[i]["codasegurado"]=='0'? '' : lista_data[i]["codasegurado"];
          }
          
          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array();
          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["codejecutivo"];
              obj.text = lista_tipos_ejecutivos[i]["desejecutivo"];
              tiposEjecutivos.push(obj);
          }
          this.valEjecutivos = tiposEjecutivos;

          this.datosFormularioEstado = response.data.festado;

          this.buscar();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      //this.multipleSelection = [];
      //this.data = [];
      return apiNomPendVB
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codejecutivo,
          this.datosFormulario.codasegurado == ''? '0' : this.datosFormulario.codasegurado 
        )
        .then((response) => {
          
          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha Est. Config") 
          && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else if ((column.property == "MONTO")
                 && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Pendientes de Aprobación</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["SINIESTRO"] == undefined){
          this.data[key]["SINIESTRO"] = "";
        }
        if(this.data[key]["EJECUTIVO"] == undefined){
          this.data[key]["EJECUTIVO"] = "";
        }
        if(this.data[key]["PRODUCTO"] == undefined){
          this.data[key]["PRODUCTO"] = "";
        }
        if(this.data[key]["ASEGURADO"] == undefined){
          this.data[key]["ASEGURADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["MONEDA"] == undefined){
          this.data[key]["MONEDA"] = "";
        }
        if(this.data[key]["MONTO"] == undefined){
          this.data[key]["MONTO"] = "";
        }
        if(this.data[key]["ESTADO"] == undefined){
          this.data[key]["ESTADO"] = "";
        }
        if(this.data[key]["OBSERVACION"] == undefined){
          this.data[key]["OBSERVACION"] = "";
        }

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["EJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["PRODUCTO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONEDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MONTO"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ESTADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["OBSERVACION"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    DocContishare(siniestro, row){
      this.$Progress.start();
      return apiNomina
        .DocContishare(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          siniestro
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataDocContishare = response.data.res1;
          this.datalink = row;
          this.nroSiniestroSeleccionado = siniestro;
          this.modalDocContishare = true;
           
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },


    autorizar(){
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SINIESTRO);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SINIESTRO"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */


      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
          siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
      }

      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiNomPendVB
          .autorizar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Autorizar",
                "Se han guardado los registros marcados para autorizar.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    rechazar(){
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SINIESTRO);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SINIESTRO"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */


      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
          if (marcados[index]["ESTADO"] != "REC"){
            siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
          }
      }

      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiNomPendVB
          .rechazar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Rechazar",
                "Se han guardado los registros marcados para rechazar.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    validarDesmarcados(){
      var ret = false;
      this.multipleSelectionDelete = [];
      for (var index = 0; index < this.data.length; ++index) {
          if (this.data[index]["chk"] == "1"){
            if (!this.multipleSelection.includes( this.data[index])){
              this.multipleSelectionDelete.push(this.data[index]);
              ret = true;
            }
          }
      }
      return ret;
    },

    buscarAsegurado(){
      this.$Progress.start();
      return apiNomPendVB
        .nombre_asegurado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codasegurado 
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (response.data.res.length > 0) {
            this.datosFormulario.desasegurado = response.data.res[0].nombre_asegurado;
          } else {
            this.datosFormulario.codasegurado = '';
            this.datosFormulario.desasegurado = '';
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    guardarObservacion(){
      apiNomPendVB
          .guardar_observacion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.modalDataObservacion.SINIESTRO,
            this.modalDataObservacion.OBSERVACION
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Observación",
                "Observación guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    }
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            if (lista[index]["chk"] == "1"){
              this.toggleSelection([lista[index]]);
            }
        }
      })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
</style>
